function clean(value) {
  return String(value || '').trim();
}
export function formatBusinessAddress(address = {}) {
  return [
    clean(address.display_name),
    clean(address.street),
    [clean(address.postal_code), clean(address.city)].filter(Boolean).join(' '),
    clean(address.country),
  ].filter(Boolean).join('\n');
}

function normalizedFilename(document) {
  return clean(document?.filename).toLocaleLowerCase('de-DE');
}

export function findBusinessAddressDocuments(documents = [], customerId) {
  const matchingCustomerDocuments = documents.filter((document) => (
    String(document?.customer_id) === String(customerId)
  ));

  return {
    addressConfirmation: matchingCustomerDocuments.find((document) => (
      /^address-usage-confirmation-.*\.pdf$/i.test(clean(document?.filename))
      || normalizedFilename(document).includes('adressbestätigung')
      || normalizedFilename(document).includes('adressbestaetigung')
    )) || null,
    usageAgreement: matchingCustomerDocuments.find((document) => (
      /^nutzungsvereinbarung-.*\.pdf$/i.test(clean(document?.filename))
      || normalizedFilename(document).includes('usage agreement')
    )) || null,
  };
}
